export enum CalendarViewType {
  Day = 1,
  Week = 2,
  Month = 3,
  Staff = 4,
  MonthBeta = 5
}
